import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { resetPassword } from "../redux/slices/authSlice";
import AuthLayout from "../components/AuthLayout";
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const ResetPasswordPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { uidb64, token } = useParams();
  const { resetPasswordStatus, resetPasswordError } = useSelector((state) => state.auth);
  const [formData, setFormData] = useState({
    new_password: "",
    confirm_password: "",
  });
  const [showPassword, setShowPassword] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(resetPassword({ uidb64, token, ...formData }));
  };

  useEffect(() => {
    if (resetPasswordStatus === "succeeded") {
      toast.success("Password reset successfully!");
      setTimeout(() => navigate('/login'), 3000);
    } else if (resetPasswordStatus === "failed") {
      toast.error(
        resetPasswordError?.non_field_errors?.[0] ||
        resetPasswordError?.password?.[0] ||
        "An error occurred. Please try again."
      );
    }
  }, [resetPasswordStatus, resetPasswordError, navigate]);

  return (
    <AuthLayout activeTab="login">
      <div className="welcome-message">
        <h3 className="text-center mb-4">Set New Password</h3>
        <p className="text-muted text-center mb-4">
          Enter your new password below.
        </p>
      </div>

      <form onSubmit={handleSubmit}>
        <div className="mb-3">
          <label htmlFor="new_password" className="form-label text-muted">
            New Password
          </label>
          <div className="position-relative">
            <input
              type={showPassword ? "text" : "password"}
              className="form-control custom-input"
              id="new_password"
              name="new_password"
              value={formData.new_password}
              onChange={handleInputChange}
              required
            />
            <button
              type="button"
              className="btn btn-link position-absolute end-0 top-50 translate-middle-y pe-3"
              onClick={() => setShowPassword(!showPassword)}
              style={{ border: "none", background: "none", color: "rgb(33, 60, 122)" }}
            >
              <i className={`fas ${showPassword ? "fa-eye-slash" : "fa-eye"}`}></i>
            </button>
          </div>
        </div>

        <div className="mb-3">
          <label htmlFor="confirm_password" className="form-label text-muted">
            Confirm Password
          </label>
          <input
            type={showPassword ? "text" : "password"}
            className="form-control custom-input"
            id="confirm_password"
            name="confirm_password"
            value={formData.confirm_password}
            onChange={handleInputChange}
            required
          />
          {resetPasswordError && (
            <div className="text-danger mt-2">
              {resetPasswordError?.non_field_errors?.[0] || resetPasswordError?.password?.[0] || "Error occurred"}
            </div>
          )}
        </div>

        <button
          type="submit"
          className="btn btn-primary w-100 custom-btn"
          disabled={resetPasswordStatus === "loading"}
        >
          {resetPasswordStatus === "loading" ? "Resetting..." : "Reset Password"}
        </button>
      </form>

      <div className="text-center mt-3">
        <a href="/login" className="text-warning text-decoration-none">
          Back to Login
        </a>
      </div>

      <ToastContainer />
    </AuthLayout>
  );
};

export default ResetPasswordPage;